/**
 * Todo Service
 *
 * Exposes the app-wide {@link ITodoService} instance — Supabase is the only
 * implementation (mock mode was removed app-wide).
 *
 * @module features/todo-list/services/todoService
 */

import { SupabaseTodoService } from './supabaseTodoService';
import type { ITodoService } from './todoService.types';

export type { ITodoService } from './todoService.types';

/**
 * Todo service instance — Supabase-backed.
 */
export const todoService: ITodoService = new SupabaseTodoService();

// Export class for testing
export { SupabaseTodoService };
